import React from 'react';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { FiChevronLeft, FiHelpCircle } from 'react-icons/fi';
import { ff } from '../../../theme';

function openCrispSupport() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }
}

/** White sticky header shared by marketplace accept + in-progress order screens. */
export function MarketplaceOrderStickyHeader(props: {
  onBack: () => void;
  avatarLetter: string;
  brandName: string;
  instagramHandle?: string | null;
  /** Right column (status pill + subtitle). */
  trailing?: React.ReactNode;
  /** Optional block below the brand row (e.g. lifecycle stepper). */
  children?: React.ReactNode;
  /** Top-right frosted Support control (same Crisp behavior as collab details). */
  showSupport?: boolean;
}) {
  const ig = props.instagramHandle?.trim();

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      borderBottom="1px solid"
      borderColor={ff.line}
      bg="white"
      fontFamily="display"
      px={4}
      pt={3}
      pb={4}
    >
      <Flex align="center" justify="space-between" mb={3}>
        <IconButton
          aria-label="Back"
          icon={<FiChevronLeft size={22} strokeWidth={2.4} />}
          w="44px"
          h="44px"
          minW="44px"
          borderRadius="full"
          bg={ff.grey}
          color={ff.ink}
          _hover={{ bg: ff.line }}
          onClick={props.onBack}
        />
        {props.showSupport ? (
          <Box
            as="button"
            type="button"
            aria-label="Support"
            h="44px"
            px={4}
            gap={2}
            bg={ff.grey}
            color={ff.ink}
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            _hover={{ bg: ff.line }}
            onClick={openCrispSupport}
          >
            <Box as={FiHelpCircle} boxSize="16px" aria-hidden />
            <Text fontSize="14px" fontWeight="600">
              Support
            </Text>
          </Box>
        ) : (
          <Box />
        )}
      </Flex>

      <Flex align="center" gap={3}>
        <Flex w="56px" h="56px" borderRadius="16px" bg={ff.ink} align="center" justify="center" flexShrink={0}>
          <Text textStyle="display" color={ff.lime} fontSize="22px">
            {props.avatarLetter}
          </Text>
        </Flex>

        <Box flex={1} minW={0}>
          <Text textStyle="display" fontSize="22px" color={ff.ink} noOfLines={1}>
            {props.brandName}
          </Text>
          <Text fontSize="14px" color={ff.text2} noOfLines={1}>
            {ig ? `@${ig}` : ''}
          </Text>
        </Box>

        {props.trailing}
      </Flex>

      {props.children}
    </Box>
  );
}
